



































import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { Department } from "../../../domain/department";
import { MultiOrderableSelectableMixin } from "../../system/selectors/mixins";
import OptionListBoxSelector from "../../system/selectors/OptionListBoxSelector.vue";
import MultiOrderableOptionListBoxSelector from "../../system/selectors/MultiOrderableOptionListBoxSelector.vue";
import { DepartmentSelectableMixin } from "./mixins";

@Component({
  components: {
    OptionListBoxSelector,
    MultiOrderableOptionListBoxSelector,
  },
})
export default class MultiOrderableDepartmentListSelector extends Mixins(DepartmentSelectableMixin, MultiOrderableSelectableMixin) {
  @Prop()
  shouldShowSelectionCount: boolean;

  @Prop()
  selectionMaxCount: number;

  @Prop({ default: false })
  isVisible: boolean;

  @Prop({ default: false })
  defaultMultiSelect: boolean;

  @Emit()
  dblclick(selectedOption: Department): void {}

  $refs!: {
    selector: OptionListBoxSelector;
  };

  data(): any {
    return {
      isMultiSelectChecked: false,
      isMultiSelectMode: false,
      singleEditingSource: null,
      isInitializing: false,
    };
  }
  isMultiSelectChecked: boolean;
  isMultiSelectMode: boolean;
  singleEditingSource: Department;
  isInitializing: boolean;

  mounted() {
    this.initialize();
  }

  get isSelectionCountVisible(): boolean {
    return this.shouldShowSelectionCount && this.isMultiSelectMode;
  }

  private async initialize(): Promise<void> {
    this.isInitializing = true;
    this.singleEditingSource = (this.editingSource && this.editingSource.length === 1)
      ? this.editingSource[0]
      : null;
    this.isMultiSelectChecked = this.defaultMultiSelect;
    this.onIsMultiSelectCheckedChanged(this.defaultMultiSelect);
    if (this.$refs.selector) {
      this.$refs.selector.scrollIntoView();
    }
    this.isInitializing = false;
  }

  @Watch("isVisible")
  onIsVisibleChanged(newValue: boolean) {
    if (newValue) {
      this.initialize();
    }
  }

  @Watch("singleEditingSource")
  onSingleEditingSourceUpdated(newValue: Department): void {
    if (newValue) {
      this.editingSource = [newValue];
    } else if (!this.isMultiSelectChecked) {
      this.editingSource = [];
    }
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: Department[]): void {
    if (newValue && newValue.length === 1) {
      this.singleEditingSource = newValue[0];
    } else if (this.isMultiSelectMode) {
      this.singleEditingSource = null;
    }
  }

  @Watch("isMultiSelectChecked")
  async onIsMultiSelectCheckedChanged(newValue: boolean): Promise<void> {
    if (!newValue && this.editingSource && this.editingSource.length > 1) {
      if (this.isInitializing) {
        this.isMultiSelectChecked = true;
        return;
      }
      const index = await this.$commonDialogs.confirmation.confirmDestructCancel(
        "確認",
        ["選択中の内容を破棄しますが、よろしいですか？"]
      );
      if (index === 0) {
        this.editingSource = [];
        this.isMultiSelectMode = false;
      } else {
        this.isMultiSelectChecked = true;
      }
      return;
    }
    this.isMultiSelectMode = newValue;
  }
}
